/*!
 * @copyright
 * Copyright(c) 2018 SICK AG
 */
import { CapNames, Director, MaterialType, Stage, DefaultCaps, DefaultNavigators, SceneCompass } from '@sick-davinci/glow';
import { FileChooser } from '@sick-davinci/basic-elements';
import { Vector3 } from 'three';

export const dependencies = [FileChooser];
/**
 * Demo:    STLLoader
 * Description:
 *  This demo application displays a loaded STL model.
 * Features:
 *  - Orbit navigation with custom settings
 *  - Capability handling (STL loading)
 */
export const run = ((viewParent: HTMLElement) => {

  // * Setup the stage *
  const stage = new Stage(viewParent, {
    cameras: [
      {
        name: 'default',
        from: [25, 0, 0],
        to: [0, 0, 0],
        up: [0, 0, 1],
        fov: 60,
      },
    ],
    scenes: [{
      name: 'default',
      }],
    viewports: [
      {
        name: 'default',
        scene: 'default',
        camera: 'default',
        navigator: 'orbit',
        bgcolor: 0x393939,
      },
    ],
  });

  // * Add an Orbit Navigator
  DefaultNavigators.initOrbit(stage, 'orbit', {rotateAround: {up: new Vector3(0, 0, 1)}});
  SceneCompass.create(stage, 'default', 'default');

  // * Data handling using capabilities
  const director = new Director(stage);
  DefaultCaps.init(director);

  director.handle(CapNames.LIGHT, { payload: { lightType: 'spot', color: 0x777777 }, orientation: { position: [10, 10, 0] } });
  director.handle(CapNames.LIGHT, { payload: { lightType: 'spot', color: 0x777777 }, orientation: { position: [-10, 10, 0] } });
  director.handle(CapNames.LIGHT, { payload: { lightType: 'ambient', color: 0x777777 } });

  stage.start();

  function loadSTLFile(fName: string, scale, position) {
    director.handleCapData({
      capability: CapNames.STLFILE,
      payload: { stlFile: fName },
      orientation: {
        rotation: [0, 0, Math.PI / 2],
        scale,
        position,
      },
      materials: [{ type: MaterialType.phong, params: { color: 0xf49100 } }],
    });
  }

  loadSTLFile('./resources/Vitruvian.stl', [5, 5, 5], [0, -8, -7]);

  // * UI Handling *
  const selFile = document.getElementById('selectFile') as FileChooser;
  selFile.addEventListener('change', (event) => {
     loadSTLFile(URL.createObjectURL((event as CustomEvent).detail[0]), [1, 1, 1], [0, 0, 0]);
   });

});
